import { createContext } from "react";
import type { WorkoutLabelOptionsContextType } from "../WorkoutLabelOptionsProvider.types";

const WorkoutLabelOptionsContext = createContext<WorkoutLabelOptionsContextType | undefined>(undefined);
WorkoutLabelOptionsContext.displayName = "WorkoutLabelOptionsContext";

export default WorkoutLabelOptionsContext;
